// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"929fc6f5","703":"4e84ca08","787":"b0342af6"}[chunkId] + ".chunk.js";
};